// A clip's still frame, made in the browser: the GIF's first frame drawn to a
// canvas. The HTML spec has drawImage take an animated image's first frame
// (its default image), whatever the <img> is showing. The Scout shows the still
// when reduced motion is asked for. A PNG, or a WebP when the PNG would be over
// the API's 2 MB limit for a still (vortex-api lib/helpMedia.ts).

import { MEDIA_LIMITS } from './data/help';

const encode = (canvas: HTMLCanvasElement, type: string, quality?: number) =>
  new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, type, quality));

export async function stillFrame(gif: Blob): Promise<Blob> {
  const url = URL.createObjectURL(gif);
  try {
    const img = new Image();
    img.src = url;
    await img.decode();
    const canvas = document.createElement('canvas');
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('This browser cannot draw the still frame');
    ctx.drawImage(img, 0, 0);
    const png = await encode(canvas, 'image/png');
    if (png && png.size <= MEDIA_LIMITS.still) return png;
    const webp = await encode(canvas, 'image/webp', 0.9);
    if (webp && webp.type === 'image/webp' && webp.size <= MEDIA_LIMITS.still) return webp;
    throw new Error('The still frame is over 2 MB; make the clip smaller');
  } finally {
    URL.revokeObjectURL(url);
  }
}
